import axios, { type AxiosInstance, type AxiosResponse, type AxiosError } from 'axios';

// Configuração base da API (ambiente dinâmico)
const API_CONFIG = {
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
  timeout: 30000, 
  withCredentials: true,  // Enviar cookies/sessão nas requisições
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
};

const apiClient: AxiosInstance = axios.create(API_CONFIG);

apiClient.interceptors.request.use(
  (config) => {
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    
    // const errorInfo = {
    //   url: error.config?.url,
    //   method: error.config?.method?.toUpperCase(),
    //   status: error.response?.status,
    //   message: (error.response?.data as { error?: string })?.error || error.message
    // };



    switch (error.response?.status) {
      case 401:
        console.warn('🔒 Usuário não autorizado - sessão expirada');
        // Não redirecionar se for a rota de verificação de sessão (checkAuth)
        // ou se já estiver em rotas públicas
        const isAuthCheckEndpoint = error.config?.url?.includes('/api/v1/auth/me');
        const isPublicRoute = window.location.pathname.includes('/login') || 
                              window.location.pathname.includes('/cadastro') ||
                              window.location.pathname.includes('/register') ||
                              window.location.pathname.includes('/esqueci-senha');
        
        // Só redireciona se não for verificação de sessão e não estiver em rota pública
        if (typeof window !== 'undefined' && !isAuthCheckEndpoint && !isPublicRoute) {
          console.log('➡️ Redirecionando para login...');
          localStorage.removeItem('user');
          window.location.href = '/login';
        }
        break;
      
      case 403:
        console.warn('🚫 Acesso negado - permissões insuficientes');
        break;
      
      case 422:
        console.warn('📝 Dados inválidos - erro de validação');
        break;
      
      case 500:
        console.error('🔥 Erro interno do servidor');
        break;
      
      default:
        console.error('🌐 Erro de conectividade ou servidor indisponível');
    }

    return Promise.reject(error);
  }
);

export const checkApiHealth = async (): Promise<boolean> => {
  try {
    await apiClient.get('/up');
    return true;
  } catch (error) {
    console.warn('API não disponível:', error);
    return false;
  }
};


export default apiClient;